import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../../../constants/constants';
import { UtilService } from '../../../services/util.service';
import { Router } from '@angular/router';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { AutenticacionService } from '../services/autenticacion.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UsuarioService } from '../../../services/usuario.service';
import { FuncionalidadService } from '../../../services/funcionalidad.service';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../../services/notification.service';
import { ProcessService } from '../../../services/process.service';
import { SocketService } from '../../../services/socket.service';
import { UsuariosGestoresService } from '../../../services/empresas/usuarios-gestores.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrl: './detalle.component.scss',
})
export class DetalleComponent implements OnInit, OnDestroy {
  nombreUsuario: string;
  correoElectronico?: string;
  numeroDocumentoUsuario: string;
  rutaAdminCuenta: string;
  idUsuario?: number;
  tipoUsuario?: string;
  infoPantalla: InfoPantallaDTO = {};

  roles: any[] = [];
  mostrarRoles: boolean = false;
  isSecure = environment.esHttps;

  private userInformation?: UserDataDto;

  private roleSubscription?: Subscription;
  isEmpresa: boolean = false;
  constructor(
    private autenticacionService: AutenticacionService,
    private utilService: UtilService,
    private usuarioService: UsuarioService,
    private funcionalidadService: FuncionalidadService,
    protected router: Router,
    private notificationService: NotificationService,
    private processService: ProcessService,
    private socketService: SocketService,
    private usuariosGestoresService: UsuariosGestoresService,
  ) {
    this.nombreUsuario = '';
    this.numeroDocumentoUsuario = '';
    this.rutaAdminCuenta = '';
    this.correoElectronico = '';

    this.utilService.watchInfoPantalla().subscribe((info: InfoPantallaDTO) => {
      if (info) {
        this.infoPantalla = info;
      }
    });
  }

  ngOnInit(): void {
    const userInformationString = sessionStorage.getItem(
      Constants.USER_INFORMATION_STORAGE
    );

    if (userInformationString) {
      this.userInformation = JSON.parse(userInformationString);
      if (this.userInformation?.tipoUsuario?.Rol_Externo === Constants.ROL_EXTERNO_EMPRESA) {
        this.isEmpresa = true;
        this.nombreUsuario = this.userInformation?.razonSocial || '';
      } else {
        this.isEmpresa = false;
        this.nombreUsuario =
          this.userInformation?.primerNombre + ' ' + this.userInformation?.primerApellido;
      }
      this.numeroDocumentoUsuario =
        this.userInformation?.tipoDocumento + ' ' + this.userInformation?.identificacion;

      this.correoElectronico = this.userInformation?.correoElectronico;
      this.idUsuario = this.userInformation?.idUsuario;

      // Construye ruta inicial (primer login)
      this.actualizarRutaAdminCuenta();

      // Cargar roles reales desde backend
      this.cargarRolesUsuario();

      // React a cambios de rol
      this.roleSubscription = this.utilService.role$.subscribe(role => {
        if (role) {
          this.actualizarRutaAdminCuenta();
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe();
    }
  }

  private actualizarRutaAdminCuenta(): void {
    const dataRol = sessionStorage.getItem(Constants.USER_TYPE);

    if (dataRol) {
      const userType = JSON.parse(dataRol);
      this.tipoUsuario = userType.Nombre;
      if (
        userType.Rol_Externo &&
        Constants.NORMAL_USER_ROLES.includes(userType.Rol_Externo)
      ) {
        this.rutaAdminCuenta = '/administrar-cuenta';
      } else {
        this.rutaAdminCuenta = '/administrar-cuenta-administrativa';
      }
      return;
    }
  }

  cargarRolesUsuario(): void {
    if (this.idUsuario) {
      this.usuarioService.consultarTiposUsuario(this.idUsuario).subscribe({
        next: resp => {
          this.roles = resp.tiposUsuario.map(tipo => ({
            Id: tipo.Id,
            Nombre: tipo.Tipo_Usuario,
            Id_Entidad: tipo.Id_Entidad,
            Rol_Externo: tipo.Rol_Externo,
          }));

          this.mostrarRoles = this.roles.length > 1;

          this.enriquecerRolesGestor();

          const currentUserTypeString = sessionStorage.getItem(Constants.USER_TYPE);

          if (currentUserTypeString) {
            const currentUserType = JSON.parse(currentUserTypeString);

            const rolActual = this.roles.find(
              r => r.Id === currentUserType.Id || r.Nombre === currentUserType.Nombre
            );

            if (rolActual) {
              console.log('Actualizando user_type con Rol_Externo:', rolActual);

              sessionStorage.setItem(Constants.USER_TYPE, JSON.stringify(rolActual));

              this.tipoUsuario = rolActual.Nombre;
              this.actualizarRutaAdminCuenta();
            }
          }
        },
        error: err => {
          console.error('Error al cargar roles:', err);
        },
      });
    }
  }

  cambiarRol(rol: any): void {
    sessionStorage.setItem(Constants.USER_TYPE, JSON.stringify(rol));
    this.utilService.setRole(rol.Nombre);
    this.tipoUsuario = rol.Nombre;
    if (rol.Rol_Externo === Constants.ROL_EXTERNO_EMPRESA) {
      this.isEmpresa = true;
      this.nombreUsuario = this.userInformation?.razonSocial || '';
    } else {
      this.isEmpresa = false;
      this.nombreUsuario =
        this.userInformation?.primerNombre + ' ' + this.userInformation?.primerApellido;
    }
    this.actualizarRutaAdminCuenta();

    let token;
    if (!this.isSecure) {
      const accessToken = sessionStorage.getItem(Constants.ACCESS_TOKEN);
      token = accessToken ?? undefined;
    }

    this.funcionalidadService
      .cargarFuncionalidadesPorTipoUsuario(rol.Id, token)
      .subscribe({
        next: response => {
          sessionStorage.setItem(Constants.FUNCIONALIDADES, JSON.stringify(response));

          console.log("USER INFORMATION", this.userInformation);
          console.log("ROL", rol);

          let rutaDestino: string;
          if (
            rol.Rol_Externo === Constants.ROL_EXTERNO_CIUDADANO ||
            rol.Rol_Externo === Constants.ROL_EXTERNO_ABOGADO ||
            rol.Rol_Externo === Constants.ROL_EXTERNO_GESTOR_EMPRESA
          ) {
            rutaDestino = '/procesos/resumen';
          } else if (rol.Rol_Externo === Constants.ROL_EXTERNO_EMPRESA) {
            rutaDestino = '/empresa/gestion-usuarios';
          } else {
            rutaDestino = response[0]?.url || '/';
          }

          if (rol.Rol_Externo === Constants.ROL_EXTERNO_GESTOR_EMPRESA) {
            this.obtenerEmpresasDelGestorYNavegar(rol, rutaDestino);
          } else if (
            rol.Rol_Externo === Constants.ROL_EXTERNO_CIUDADANO ||
            rol.Rol_Externo === Constants.ROL_EXTERNO_ABOGADO
          ) {
            this.sincronizarExpedientesCiudadanoYNavegar(rol, rutaDestino);
          } else {
            this.navegarARuta(rutaDestino);
          }
        },
        error: err => {
          console.error('Error al cargar funcionalidades:', err);
        },
      });
  }

  private obtenerEmpresasDelGestorYNavegar(rol: any, rutaDestino: string): void {
    if (rol.empresaInfo && this.userInformation) {
      console.log(`Sincronizando expedientes para empresa: ${rol.empresaInfo.razonSocial} (NIT: ${rol.empresaInfo.nit})`);

      this.startUserProcess(
        rol.empresaInfo.nit,
        rol.empresaInfo.tipoDocumento,
        rol.empresaInfo.idTipoDocumento,
        this.userInformation.idUsuario || 0,
        rol.Id
      );

      setTimeout(() => {
        this.navegarARuta(rutaDestino);
      }, 2000);
    } else {
      console.warn('No se encontró información de empresa para el rol seleccionado');
      this.navegarARuta(rutaDestino);
    }
  }

  private sincronizarExpedientesCiudadanoYNavegar(rol: any, rutaDestino: string): void {
    if (!this.userInformation) {
      console.error('No se encontró userInformation');
      this.navegarARuta(rutaDestino);
      return;
    }

    console.log(`Sincronizando expedientes para ciudadano: ${this.userInformation.primerNombre}`);

    this.startUserProcess(
      this.userInformation.identificacion || '',
      this.userInformation.tipoDocumento || '',
      this.userInformation.idTipoDocumento || 0,
      this.userInformation.idUsuario || 0,
      rol.Id
    );
    setTimeout(() => {
      this.navegarARuta(rutaDestino);
    }, 1000);
  }

  private navegarARuta(ruta: string): void {
    this.router.navigateByUrl(ruta).then(() => {
      this.utilService.notifyRoleChange();
    });
  }


  esRolActivo(rol: any): boolean {
    const dataRol = sessionStorage.getItem(Constants.USER_TYPE);
    if (dataRol) {
      const userType = JSON.parse(dataRol);
      return userType.Id === rol.Id && userType.Nombre === rol.Nombre;
    }

    return false;
  }

  async logout() {
    const abrirLogoutADLU = () => {
      const a = document.createElement('a');
      a.href = environment.AUTH_LOGOUT_TAB_URL;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    if (this.infoPantalla.change) {
      await this.infoPantalla.change(() => {
        this.autenticacionService.logout();
        this.router.navigate(['/login']);
        abrirLogoutADLU();
      });
    } else {
      this.autenticacionService.logout();
      this.router.navigate(['/login']);
      abrirLogoutADLU();
    }
  }

  async administrarCuenta() {
    try {
      const isLoggedIn = sessionStorage.getItem(Constants.IS_SUCCESS_LOGIN);
      const userInfo = sessionStorage.getItem(
        Constants.USER_INFORMATION_STORAGE
      );
      if (isLoggedIn !== '1' || !userInfo) {
        console.error('Sesión no válida al intentar administrar cuenta');
        this.router.navigate(['/login']);
        return;
      }

      this.actualizarRutaAdminCuenta();

      await this.router.navigateByUrl(this.rutaAdminCuenta);
    } catch (error) {
      console.error('Error al navegar a administrar cuenta:', error);
    }
  }

  private startUserProcess(
    numeroIdentificacion: string,
    tipoIdentificacion: string,
    idTipoDocumento: number,
    idUsuario: number,
    idTipoUsuario: number,
    esManual: boolean = false
  ): void {
    if (!numeroIdentificacion || !tipoIdentificacion) {
      this.notificationService.addNotification(
        'error',
        'Número de identificación o tipo de identificación no definidos'
      );
      return;
    }

    // Llama al backend para sincronizar los expedientes
    this.processService
      .sincronizarExpedientes(
        numeroIdentificacion,
        tipoIdentificacion,
        idTipoDocumento,
        idUsuario,
        idTipoUsuario,
        esManual
      )
      .subscribe({
        next: () => {
          this.notificationService.addNotification(
            'success',
            'Sincronización de expedientes iniciada exitosamente'
          );
        },
        error: () => {
          this.notificationService.addNotification(
            'error',
            'Error al sincronizar expedientes'
          );
        },
      });

    // Acumulador de cambios
    const cambiosExpedientes: { radicado: string; action: string }[] = [];
    let timeout: any = null;

    // Escucha las notificaciones de cambios en los expedientes
    this.socketService.listenToExpedienteChanges(data => {
      cambiosExpedientes.push(data);

      // Reinicia el temporizador cada vez que llega un nuevo cambio
      if (timeout) {
        clearTimeout(timeout); // Cancela cualquier temporizador anterior
      }

      // Programa la consolidación después de un periodo de inactividad
      timeout = setTimeout(() => {
        if (cambiosExpedientes.length > 0) {
          // Filtrar los radicados y agruparlos por acción
          const creados = cambiosExpedientes
            .filter(item => item.action === 'created')
            .map(item => item.radicado)
            .join(', ');

          const actualizados = cambiosExpedientes
            .filter(item => item.action === 'updated')
            .map(item => item.radicado)
            .join(', ');

          // Crear mensajes resumidos
          if (creados) {
            this.notificationService.addNotification(
              'info',
              `Los siguientes expedientes han sido creados: ${creados}`
            );
          }
          if (actualizados) {
            this.notificationService.addNotification(
              'info',
              `Los siguientes expedientes han sido actualizados: ${actualizados}`
            );
          }

          // Limpia el acumulador
          cambiosExpedientes.length = 0;
          timeout = null;
        }
      }, 3000);
    });
  }

  private enriquecerRolesGestor(): void {
    const rolesGestor = this.roles.filter(
      rol => rol.Rol_Externo === Constants.ROL_EXTERNO_GESTOR_EMPRESA
    );

    if (rolesGestor.length > 0 && this.userInformation?.idPersona) {
      this.usuariosGestoresService
        .obtenerEmpresasPorGestor(this.userInformation.idPersona)
        .subscribe({
          next: response => {
            if (response.data.tieneEmpresas && response.data.empresas.length > 0) {
              rolesGestor.forEach(rol => {
                const empresa = response.data.empresas.find(
                  emp => rol.Nombre.includes(emp.razonSocial)
                );

                if (empresa) {
                  rol.empresaInfo = {
                    nit: empresa.nit,
                    razonSocial: empresa.razonSocial,
                    tipoDocumento: empresa.tipoDocumento,
                    idTipoDocumento: empresa.idTipoDocumento,
                  };
                }
              });

              console.log('Roles enriquecidos con info de empresa:', this.roles);
            }
          },
          error: err => {
            console.error('Error al enriquecer roles con empresas:', err);
          },
        });
    }
  }

}
